const ShowMoney = ({ money }: { money: number }) => {
  return (
    <div className="flex flex-col items-center dark:text-slate-200 text-slate-800 mt-5">
      <div className="text-lg font-bold mb-2">
        💰보유 포인트💰 {money} 포인트
      </div>
    </div>
  );
};

export default ShowMoney;
